export interface IPointPack {
  title: string;
  price: string;
  points: number | string;
  popular?: boolean;
  isCustom?: boolean;
}

export const DEFAULT_POINT_PACKS: IPointPack[] = [
  { title: 'Starter Pack', price: '$4.99', points: 1000 },
  { title: 'Pro Pack', price: '$9.99', points: 2500, popular: true },
  { title: 'Elite Pack', price: '$19.99', points: 5000 },
];
